/* Copyright (c) 2020-2025 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { useState } from "react";
import {
  useDeleteGroupMutation,
  DeleteGroupMutation,
} from "~/generated/graphql";
import { showError } from "~/services/toast";
import { removeFromApolloCache } from "~/tools";

type Props = {
  onSuccess: () => void;
};

export function useDeleteResourceGroup({ onSuccess }: Props) {
  const [id, setId] = useState("");
  const [deleteResourceGroupMutation, { client, ...rest }] =
    useDeleteGroupMutation({
      onCompleted: (data: DeleteGroupMutation) => {
        if (data.removeGroup) {
          onSuccess();
          removeFromApolloCache(client.cache, `Group:${id}`, "groups");
        } else {
          showError();
        }
      },
    });

  async function deleteResourceGroup(resourceGroupId: string) {
    setId(resourceGroupId);
    await deleteResourceGroupMutation({
      variables: {
        id: resourceGroupId,
      },
    });
  }

  return [deleteResourceGroup, { client, ...rest }] as const;
}
